import {
    AccountApplicationContext,
    type AccountApplicationContextType,
} from '@context/account-application/account-application-context';
import {
    AccountApplicationActions,
    type AccountApplicationActionsType,
} from '@context/account-application/account-application-context-actions';
import { useContext } from 'react';

export const useAccountApplication = (): AccountApplicationContextType => {
    const accountApplicationStateContext = useContext(AccountApplicationContext);

    return accountApplicationStateContext;
};

export const useAccountApplicationActions = (): AccountApplicationActionsType => {
    const accountApplicationActionsContext = useContext(AccountApplicationActions);

    return accountApplicationActionsContext;
};

export const useSelectedChildEligibility = () => {
    const { selectedChildEligibility } = useAccountApplication();

    return selectedChildEligibility;
};

// TODO: useSelectedChild() function to get child object only
